import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const LoadingContainer = styled.div`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	gap: 3%;
	padding: 0px 20px 20px;
	background-color: ${tokens.color_white};
	width: 100%;
	height: 300px;
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0px 20px 20px;
	background-color: ${tokens.color_white};
`;

export const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
	gap: 24px;
	padding: 0px 20px 20px;
	background-color: ${tokens.color_white};
`;

export const Card = styled.div`
	background-color: ${tokens.color_gray_light};
	border-radius: 8px;
	padding: 24px 24px 36px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const CardTitle = styled.h3`
	font-size: 1rem;
	font-weight: 600;
	color: ${tokens.color_gray_dark};
	margin: 0;
`;

export const CardInfo = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const InfoLink = styled.span`
	color: ${tokens.color_primary};
	font-size: 16px;
	font-weight: 600;
	text-decoration: underline;
	display: flex;
	gap: 15px;
	align-items: center;
	text-underline-offset: 2px;
	cursor: pointer;
`;
